goog.provide("shadow.js.shim.module$$mui$material$AccordionSummary");
goog.provide("module$shadow_js_shim_module$$mui$material$AccordionSummary");
shadow.js.shim.module$$mui$material$AccordionSummary = shadow.js.nativeProvides["@mui/material/AccordionSummary"] = shadow$bridge("@mui/material/AccordionSummary");
module$shadow_js_shim_module$$mui$material$AccordionSummary.default = shadow.js.shim.module$$mui$material$AccordionSummary;
